import { stringifyQueryStringObject } from "../../../../services/parseQueryString";
import {
  animateNavigationToNewPath,
  getFilteredQueryString,
  setupLoanRoute
} from "@utils/helpers/navigators";

export const createVerifyStepNavigator = (fullPath, stepName) => {
  const shouldRouteBeActive = (verifyState, pathname) => {
    const { nextScreen } = verifyState;
    return pathname !== fullPath && nextScreen === stepName;
  };
  
  const navigateTo = (navigate, verifyState, queryString = {}) => {
    const { accountExternalId } = verifyState;

    if(!!accountExternalId) {
      queryString.id = accountExternalId;
    }
    const filteredQueryString = getFilteredQueryString(queryString);
    const search = stringifyQueryStringObject(filteredQueryString);
    
    const newPath = fullPath + search;
    
    animateNavigationToNewPath(navigate, newPath);
  };

  return setupLoanRoute({shouldRouteBeActive, navigateTo});
}